import { createAsyncAction } from "../utils"
import { api as externalApi } from "../../services/api"
import types from "./types"

const api = externalApi()

export const fetchStatistics = createAsyncAction(
  types.FETCH_STATISTICS,
  api.statistics.getStatistics
)
